import type { ProductListViewModel } from 'autogen/swagger/all';
import ProductListPage from './ProductListPage';
import ContentfulPLP from '../Contentful/pages/ProductListPage';
import ContentfulContext from '../Contentful/ContentfulContext';

export default function RenderProductListPage({ model }: { model: ProductListViewModel }) {
    const { contentfulContent, contentfulSeoContentBlock } = model;

    if (contentfulContent || contentfulSeoContentBlock) {
        return (
            <ContentfulContext.Provider value={{ template: 'productListTemplate' }}>
                <ContentfulPLP model={model} />
            </ContentfulContext.Provider>
        );
    }

    return <ProductListPage model={model} />;
}
